import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "loginFilled"
const LoginFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21 2.063C21.932 2.063 22.688 2.818 22.688 3.75V20.25C22.688 21.182 21.932 21.938 21 21.938H11.25C10.318 21.938 9.563 21.182 9.563 20.25V14.25H11.437V20.063H20.813V3.938H11.438V9.75H9.562V3.75C9.563 2.818 10.319 2.063 11.25 2.063z" />
          <path d="M19.7 12 14.164 17.538 12.837 16.212 16.112 12.938H1.5V11.062H16.112L12.837 7.789 14.163 6.462z" />
        </svg>
      }
    </span>
  )
}
export default LoginFilledIcon
